RivalIQ.apps.Admin.module('apps', function (apps, App, Backbone, Marionette, $, _) {

    'use strict';

    const Account = apps.Account = window.createMarionetteApp();
    Account.name = 'Account';

    Account.addRegions({
        accounts: '#adminAccounts',
        accountEditModal: '#accountEditModal',
        accountDeleteModal: '#accountDeleteModal',
        accountActionsModal: '#accountActionsModal',
        accountDetails: '#adminAccountDetails'
    });

    Account.addInitializer(function (options) {
        const opts = _.pick(options, 'editCompanyId');
        Account.state = opts;
    });
});
